import styled from 'styled-components';
import { ArrowLeftRight } from 'lucide-react';
import { purpleColors, slateColors } from '../ContentPages/AppLandingPage/styles';

const SwitchButtonStyled = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 9999px;
  background: white;
  border: 2px solid ${slateColors[200]};
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  
  &:hover {
    border-color: ${purpleColors[500]};
    background: ${purpleColors[50]};
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
  
  &:focus {
    outline: none;
    border-color: ${purpleColors[500]};
    box-shadow: 0 0 0 3px ${purpleColors[100]};
  }
  
  svg {
    width: 1.125rem;
    height: 1.125rem;
    color: ${purpleColors[600]};
  }
`;

interface SwitchButtonProps {
  onClick: () => void;
  'aria-label'?: string;
}

const SwitchButton = ({ onClick, 'aria-label': ariaLabel }: SwitchButtonProps) => {
  return (
    <SwitchButtonStyled onClick={onClick} aria-label={ariaLabel || 'Switch origin and destination'}>
      <ArrowLeftRight />
    </SwitchButtonStyled>
  );
};

export default SwitchButton;

